import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'remote-update-domain-empty-state',
  templateUrl: './empty-state.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './empty-state.css'
})
export class EmptyState {
  @Input() title = '';
  @Input() description = '';
}
